'use strict';

/**
 * All JS for the LandingPage
 *
 * @type {{index: waApp.controllers.LandingPage.index, _handleProfilePanels: waApp.controllers.LandingPage._handleProfilePanels, _handleProjectPanels: waApp.controllers.LandingPage._handleProjectPanels}}
 */
waApp.controllers.LandingPage = {
	index: function () {
		// Todo: Try to refactor the NoWrapArrowLink to work targeted on a specific Markup element, not a class
		// waUtils.noWrapArrowLink('.project-panel h2');
		// waUtils.noWrapArrowLink('.profile-panel h2');
		// waUtils.noWrapArrowLink('.news-panel-title h2');

		// waApp.controllers.LandingPage._handleNewsPanels();
		waApp.controllers.LandingPage._handleProfilePanels();
		waApp.controllers.LandingPage._handleProjectPanels();
	},

	/**
	 * Handle the Profile panels when Ads are served or not.
	 * We need to remove cards based on ads format and amount of ads
	 * to fit the design
	 *
	 * @private
	 */
	_handleProfilePanels: function () {
		let gridProfiles = $('.profiles-grid').isotope({
			// options
			itemSelector: '.grid-item',
			transitionDuration: 0,
			// percentPosition: true
		});

		setTimeout(function () {
			let elems = gridProfiles.isotope('getItemElements');
			waAdSpace.calculateBannerCardHeight(elems, 400, 800, 400);

			const ids = ['#sas_47336_3', '#sas_47336_4'];
			ids.forEach(function (id) {
				const element = $(id);

				if (element.length > 0 && element.css('display') !== 'none') {
					const clientHeight = element[0].clientHeight;

					if (clientHeight === 830) {
						element.next().remove();
						element.next().remove(); // Remove the second next element
					} else if (clientHeight === 420) {
						element.next().remove();
					}
				}
			});

			gridProfiles.isotope('layout');
		}, 1002);
	},
	_handleNewsPanels: function () {
	},
	/**
	 * Handle the Project panels when ads are served or not
	 * We need to remove cards based on ads format and amount of ads
	 * to fit the design
	 *
	 * @private
	 */
	_handleProjectPanels: function () {
		let gridProjects = $('.projects-grid').isotope({
			// options
			itemSelector: '.grid-item',
			transitionDuration: 0,
			// percentPosition: true
		});

		setTimeout(function () {
			let elems = gridProjects.isotope('getItemElements');
			waAdSpace.calculateBannerCardHeight(elems, 400, 830, 420);

			const ids = ['#sas_47336', '#sas_47336_2'];
			ids.forEach(function (id) {
				const element = $(id);
				if (element.length > 0 && element.css('display') !== 'none') {
					const clientHeight = element[0].clientHeight;

					if (clientHeight === 830) {
						element.next().remove();
						element.next().remove(); // Remove the second next element
					} else if (clientHeight === 420) {
						element.next().remove();
					}
				}
			});

			gridProjects.isotope('layout');
		}, 1002);
	},
};
